import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      default: HomeView
    },
    children: [
      {
        path: '',
        name: 'Dashboard',
        components: {
          dashboard: () => import('../views/DashboardView.vue')
        }
      },
      {
        path: '/clients',
        name: 'clients',
        components: {
          dashboard: () => import('../views/ClientsView.vue')
        }
      },
      {
        path: '/lead-stage-report',
        name: 'lead-stage-report',
        components: {
          dashboard: () => import('../views/LeadStageReport.vue')
        }
      },
      {
        path: '/lead-source-report',
        name: 'lead-source-report',
        components: {
          dashboard: () => import('../views/LeadSourceReport.vue')
        }
      },
      {
        path: '/record-lead-tracker',
        name: 'RecordLeadTracker',
        components: {
          dashboard: () => import('../views/NewLeadTracker.vue')
        }
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
